export const SUPPLIER_ID_KEY = 'id';
export const SUPPLIER_NAME_KEY = 'name';
export const SUPPLIER_EMAIL_KEY = 'email';
export const SUPPLIER_NOTE_KEY = 'note';
export const SUPPLIER_PHONE_KEY = 'phone';
export const SUPPLIER_TYPE_KEY = 'type';
export const SUPPLIER_CUSTOMER_ID_KEY = 'customerId';
export const SUPPLIER_ADDRESS_KEY = 'address';
export const SUPPLIER_ACTIVE_KEY = 'active';
export const SUPPLIER_CREATED_AT_KEY = 'createdAt';
export const SUPPLIER_CREATED_BY_KEY = 'createdBy';
export const SUPPLIER_MODIFIED_AT_KEY = 'modifiedAt';
export const SUPPLIER_MODIFIED_BY_KEY = 'modifiedBy';
export const SUPPLIER_DETAIL_KEY = 'detail';
export const SUPPLIER_DELETED_AT_KEY = 'remove';

export const SUPPLIER_TABLE_KEY = 'v1/supplier';
export const SUPPLIER_TABLE_SETTINGS = 'supplier';
export const SUPPLIER_QUERY_KEY = 'suppliers';

export const TableSettingsKeys = {
  name: 'table_list.columns.suppliers.name',
  customerId: 'table_list.columns.customerId',
  email: 'table_list.columns.suppliers.email',
  phone: 'table_list.columns.suppliers.phone',
  type: 'table_list.columns.suppliers.type',
  address: 'table_list.columns.suppliers.address',
  note: 'table_list.columns.suppliers.note',
  active: 'table_list.columns.suppliers.active',
  createdAt: 'table_list.columns.createdAt',
  createdBy: 'table_list.columns.createdBy',
  modifiedBy: 'table_list.columns.modifiedBy',
  modifiedAt: 'table_list.columns.modifiedAt',
};
